<template>
    <div class="my-2 py-1 pl-1 mx-2" :class="{ 'btn-bg-color-secondary-blue': active, 'elevation-1': !active, ...$attrs }" style="border-radius: 12px" @click="$emit('outer-click')">
        <v-radio ripple :value="value" color="white" :disabled="disabled">
            <template #label>
                <span :class="{ 'white--text': active }">{{ text }}</span>
            </template>
        </v-radio>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String],
        },
        text: {
            type: String,
        },
        active: {
            type: Boolean,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
    },
};
</script>
